import { render, staticRenderFns } from "./pie-echart.vue?vue&type=template&id=395ae2de"
import script from "./pie-echart.vue?vue&type=script&lang=js"
export * from "./pie-echart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports